import isMiniFeatureEnabled, {
    MiniFeatures,
} from 'owa-mini-feature-flags/lib/isMiniFeatureEnabled';

export function stampFeatureFlags() {
    const featuresToAdd: MiniFeatures[] = ['mini-tapFeedback'];
    featuresToAdd.forEach(flag => {
        if (isMiniFeatureEnabled(flag)) {
            document.body.classList.add('feature-' + flag);
        }
    });
}
